import React from 'react';
import {Layout} from 'antd';
import LoginForm from '../components/Forms/LoginForm';
import { useTheme } from '../components/ThemeProvider';

const {Content} = Layout;

const LoginPage: React.FC = () => {
    const { isDark } = useTheme();

    return (
        <Layout style={{minHeight: '100vh', backgroundColor: isDark ? '#141414' : '#f0f2f5'}}>
            <Content style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '24px'
            }}>
                <LoginForm/>
            </Content>
        </Layout>
    );
};

export default LoginPage;